import functions from '../functions';
import { list } from './list';
import Slider from "../components/Slider";

$(() => {
    listAccommodation.init();
});

const listAccommodation = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 10,
        language: functions.getLang(),
        objectGroupId: 1,
        dates: null,
        dateFrom: null,
        dateTo: null,
        destination: '',
        dynamicPackage: false,
        hasArrival: null,
        arrivalDateFrom: null,
        arrivalDateTo: null,
        guests: '2,0,0',
    },
    params: {},
    $listItems: null,
    filterParams: {
        pool: '',
        parking: '',
        pets: '',
        internet: '',
        objectTypeId: '',
        objectName: '',
        unitServiceIds: '',
        serviceId: '',
        categoryObject: null,
        distanceBeach: null,
        distanceCenter: null
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'guests', '_page'],
    init() {
        this.$form = $('.search-accommodation');
        this.form = this.$form[0];

        if( ! this.form) {
            return;
        }

        this.$filters = $('.search-filters');
        this.$listItems = $('.list-items');
        this.isHome = this.$form.attr('data-ishome');

        if (this.$form.attr('data-countryId')) {
            this.defaults.destination = this.$form.attr('data-countryId');
        }

        this.getParams();

        functions.setFormData(this.form, this.params);

        if($('[name=guests]').val()) {
            this.params.guests = $('[name=guests]').val();
        }

        this.find(this.params);

        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            let params = functions.getFormData($target);

            if (this.$filters[0]) {
                let filterParams = functions.getFormData(this.$filters);
                params = $.extend({}, params, filterParams);
            }

            if( ! params.dates) {
                params.dateFrom = params.dateTo = null;
            }

            params._page = 1;
            if(this.isHome) {
                params = functions.cleanParams(params);
                location = $(e.target).find('[data-listurl]').attr('data-listurl') + '#' + $.param(params);
            } else {
                functions.setUrlData(params, true, true);
            }
        });

        if (this.$filters[0]) {

            functions.setFormData(this.$filters[0], this.params);

            this.$filters.find('input').on('change', e => {
                let params = functions.getFormData(this.$form);
                let filterParams = functions.getFormData(this.$filters);
                params = $.extend({}, params, filterParams);

                functions.setUrlData(params, true, true);
            });

            this.$filters.on('submit', e => {
                const $target = $(e.target);
                e.preventDefault();

                let params = functions.getFormData($target);
                let filterParams = functions.getFormData(this.$filters);
                params = $.extend({}, params, filterParams);

                functions.setUrlData(params, true, true);
            });
        }


        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $('.btn-clear-filters').on('click', e => {
            e.preventDefault();

            this.params = $.extend({}, functions.getFormData(this.$form), this.filterParams);
            this.params._page = this.defaults._page;

            functions.setUrlData(this.params, true);
            functions.setFormData(this.$filters[0], this.filterParams);
        });

        $(window).on('hashchange', e => {
            this.getParams();

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
        });


        $('#filterModal').on('click', 'input[type="radio"]', e => {
            if ( this.radioValues[e.target.name] == e.target.value ) {
                this.radioValues[e.target.name] = null;
                e.target.checked = false;
                this.$form.trigger('change');
                return;
            }
            this.radioValues[e.target.name] = e.target.value;
        });

    },
    getParams() {

        this.params = list.getParams(this.params, this.filterParams, this.defaults);
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        } else {
            this.params.dateFrom = this.params.dateTo = null;
        }

        if (this.params.guests) {
            this.params.guests = this.params.guests.startsWith('0') ? null : this.params.guests;
        }

        this.radioValues = {
            serviceId: this.params.serviceId,
            distanceBeach: this.params.distanceBeach,
            distanceCenter: this.params.distanceCenter
        };
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    find(params) {
        if(! this.params.dates) {
            this.params.dateTo = $('input[name="dateTo"]').val();
        }
        list.find(params).then((response) => {
            list.findDone(response);
            // LOZAD
            window.observer.observe();

            let listSlider = [];

            $('[id^=card-slider]').each((index, element) => {
                listSlider[index] = new Slider('#' + $(element).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slides: {
                        perView: 1,
                        spacing: 0,
                    },
                });
            });
        });
    }
};